import { render, staticRenderFns } from "./QuestionRepositoryTable.vue?vue&type=template&id=6eacd016&scoped=true"
import script from "./QuestionRepositoryTable.vue?vue&type=script&lang=js"
export * from "./QuestionRepositoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eacd016",
  null
  
)

export default component.exports